import { Laboratory } from "./laboratory";

export class Drug {
	label: string;
	dci: string;
	atc: string;
	laboratory: Laboratory;
	identifiers: { [key: string]: string };
	indicators: string[];
	icon: EDrugIcon;
}

export class AutocompleteDrug {
	label: string;
	vmp: string;
	ucd: string;
}

export class DrugDetails {
	indications: string;
	posologies: string;
}

export enum EDrugIcon {
	TABLET = 1,
	DROP = 2,
	SACHET = 3,
	NEEDLE = 4,
	PAD = 5,
	PELLET = 6,
	PATCH = 7,
	BOTTLE = 8,
	CREAM = 9,
	IUD = 10,
	SUPPOSITORY = 11,
}
